import * as types from '../ActionTypes/SearchUsersActionTypes';

export class SearchUsersActionCreators {
    static getUsers = filter => ({
        type: types.GET_ALL_USERS,
        meta: { filter },
    });

    static getUsersSuccess = (response, offset, offsetFollowers) => {
        return {
            type: types.GET_ALL_USERS_SUCCESS,
            payload: { response, offset, offsetFollowers },
        };
    };

    static getMoreUsers = (filter, offset_id, offset_followers) => ({
        type: types.GET_MORE_USERS,
        meta: { filter, offset_id, offset_followers },
    });

    static getMoreUsersSuccess = (response, offset, offsetFollowers) => {
        return {
            type: types.GET_MORE_USERS_SUCCESS,
            payload: { response, offset, offsetFollowers },
        };
    };

    static getMoreUsersEmpty = () => ({
        type: types.GET_MORE_USERS_EMPTY,
        payload: {},
    });
}



// WEBPACK FOOTER //
// ./src/Store/ActionCreators/SearchUsersActionCreators.js